import React from 'react'
import { Anchor } from '@mantine/core'
import { formatPhone } from '@phoenix-web/utils/general'
import {
  CONTACT_US_URL,
  COOKIE_POLICY_URL,
  DO_NOT_SELL_INFO_URL,
  PRIVACY_POLICY_URL,
  TERMS_OF_USE_URL,
} from '@/constants'

/** META TAG RELATED STRINGS - START */
export const SITE_META_TITLE = 'Knock Partner Dashboard'
export const SITE_META_DESCRIPTION =
  'Buy before you sell, for people who are buying and selling homes, we partner with their lenders and agents to provide cash flow and more certainty, convenience, and competitiveness. Partner with Knock Today!'
export const generateMetaTitle = (title: string) => `${title} - ${SITE_META_TITLE}`
/** META TAG RELATED STRINGS - END */

/** KNOCK SUPPORT STRINGS - START **/
export const SUPPORT_PHONE = '8669961695'
export const LISTING_TEAM_SUPPORT_PHONE = '4702508421'
export const SUPPORT_HOURS = 'Mon-Fri 9am ET to 6pm ET'
export const SUPPORT_EMAIL = 'hello@knock.com'
export const LISTING_TEAM_SUPPORT_EMAIL = 'listings@knock.com'
export const SCHEDULE_A_CALL_LINK_TEXT = 'Schedule a call'
export const CALENDLY_SUPPORT_LINK_URL =
  'https://calendly.com/d/5cs-gtr-pcj?utm_source=partners_dashboard&utm_medium=website&utm_campaign=partners_dashboard_revamp'
/** KNOCK SUPPORT STRINGS - END **/

/** FOOTER STRINGS - START */
export const FOOTER_LINKS = [
  {
    link: CONTACT_US_URL,
    label: 'Contact Us',
    target: '_blank',
  },
  {
    link: TERMS_OF_USE_URL,
    label: 'Terms of Use',
    target: '_blank',
  },
  {
    link: PRIVACY_POLICY_URL,
    label: 'Privacy Policy',
    target: '_blank',
  },
  {
    link: COOKIE_POLICY_URL,
    label: 'Privacy Policy',
    target: '_blank',
  },
  {
    link: DO_NOT_SELL_INFO_URL,
    label: 'Do Not Sell My Information',
    target: '_blank',
  },
] as const

export const KNOCK_LENDING_NMLS_ID = '1958445'
export const KNOCK_LENDING_NMLS = `Knock Lending LLC, NMLS #${KNOCK_LENDING_NMLS_ID}`
export const COPYRIGHT = `© ${new Date().getFullYear()} Knockaway, Inc.  All rights reserved.`
export const FOOTER_EQUAL_HOUSING = 'Equal Housing Opportunity'
export const FOOTER_COMPANY = (
  <>
    Knock Lending LLC
    <br />
    3715 Northside Pkwy, Building 100, Suite 500, Atlanta, GA 30327
    <br />
    <Anchor href={`tel:${SUPPORT_PHONE}`}>{formatPhone(SUPPORT_PHONE)}</Anchor>
  </>
)
export const FOOTER_LEGAL_STATEMENT_ARR = [
  'Please be advised that Knock Lending, LLC and Knock Property 1, LLC are wholly owned subsidiaries of Knockaway, Inc. (collectively "Knock") and you are NOT required to transact with any of these entities as a condition of working with Knock.',
  'Knock Property 1, LLC issues a Knock Purchase Offer ("KPO") on qualifying properties and charges a contract fee in connection with the KPO.',
  'Equal housing lender. Make sure you understand the features associated with the loan program you choose, and that it meets your unique financial needs. This is not a credit decision or a commitment to lend. Eligibility is subject to completion of an application and verification of home ownership, occupancy, title, income, employment, credit, home value, collateral, and other underwriting requirements as determined by Knock Lending, LLC.',
]
/** FOOTER STRINGS - END */

/** STAGING PAGES TEXT - START */
export const LOG_IN = 'Log in'
export const NEW_TO_KNOCK = 'New to Knock?'
export const CREATE_ACCOUNT = 'Create your account'
export const ALREADY_HAVE_ACCOUNT = 'Already have a Knock account?'
export const stagingPagesContent = {
  STAGING_WELCOME: 'Welcome to your Knock dashboard.',
  STAGING_LIST_TITLE: 'This dashboard is the homebase where you’ll:',
  STAGING_LIST_ITEMS: [
    'Qualify clients for Knock Bridge Loan',
    'Track your clients Knock journey from start to finish',
    'Access marketing materials & social media assets',
  ],
  AND_SO_MUCH_MORE: 'And so much more!',
  DURATION_TEXT: 'It takes less than 2 minutes to set up.',
}
export const createAccountContent = {
  TITLE: 'Create an account and track your client’s progress.',
  TITLE_HAS_ACCOUNT: 'Log into your account and track your client’s progress.',
}
/** STAGING PAGES TEXT - END*/

/** AUTH PAGES TEXT */
export const authSignupContent = {
  TITLE: 'Create account',
  TITLE_AUDIENCE_PICKER: 'Which describes you best?',
  LOGIN_TEXT: ALREADY_HAVE_ACCOUNT,
  LOGIN_LINK_LABEL: LOG_IN,
  ALT_CREATE_ACCOUNT: 'Create your Knock account',
}
export const authVerifyContent = {
  TITLE: 'Finalize your account',
  CHECK_EMAIL_TEXT: 'To complete your account, click the verification link in the email we’ve sent to you.',
  RESEND_EMAIL_TEXT: 'Resend verification email',
  ALREADY_VERIFIED_TEXT: 'Already verified?',
  LOGIN_LINK_LABEL: LOG_IN,
  GO_TO_DASHBOARD_LINK_LABEL: 'Go to dashboard',

  VERIFIED_TITLE_SUCCESS: 'Email verified',
  VERIFIED_TITLE_FAILURE: 'Verification expired',
  EMAIL_VERIFIED: 'Your account has been verified.',
  EMAIL_LINK_EXPIRED: 'This link has expired or has already been used.',
}
/** AUTH PAGES TEXT END */

export const PHOTO_UPLOAD_FORM_URL =
  'https://script.google.com/a/macros/knock.com/s/AKfycbykj8SFNR4LqgcIkpki0m5ZMn2R5FJOtyCvPf4lk_rnv_i1JJzKwHNGCBYtF8HZpfoO/exec'
